<template>
  <div
    class="flex items-start gap-3 rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-800 dark:border-amber-500/30 dark:bg-amber-500/10 dark:text-amber-300"
    role="status"
    data-testid="plan-required-notice"
  >
    <ExclamationTriangleIcon class="mt-0.5 size-5 shrink-0" aria-hidden="true" />
    <p>
      This needs an active plan.
      <slot />
      <template v-if="organizations.canManageBilling">
        Choose one under
        <RouterLink :to="{ name: 'Billing' }" class="font-medium underline underline-offset-2"
          >Billing</RouterLink
        >.
      </template>
      <template v-else>Ask the organization owner to choose one.</template>
      <button
        v-if="recheck"
        type="button"
        class="ml-1 font-medium underline underline-offset-2 disabled:opacity-50"
        :disabled="checking"
        data-testid="plan-recheck"
        @click="onRecheck"
      >
        {{ checking ? 'Checking…' : 'Check again' }}
      </button>
    </p>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { ExclamationTriangleIcon } from '@heroicons/vue/20/solid';
import { useOrganizationStore } from '@/stores/organization';

const props = defineProps<{ recheck?: () => Promise<unknown> }>();

const organizations = useOrganizationStore();
const checking = ref(false);

async function onRecheck() {
  checking.value = true;
  try {
    await props.recheck?.();
  } finally {
    checking.value = false;
  }
}
</script>
